import PropTypes from 'prop-types';
import React, { Component } from 'react';

import SettingsPage from '@/components/SettingsPage';
import SettingsPageContent from '@/components/SettingsPageContent';
import SettingsPageHeader from '@/components/SettingsPageHeader';
import SettingsPageTitle from '@/components/SettingsPageTitle';

import Table from './Table';

class Locations extends Component {
  static propTypes = {
    error: PropTypes.any,
    itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
    isLoading: PropTypes.bool.isRequired,
    totalCount: PropTypes.number.isRequired,
  };

  static defaultProps = {
    error: null,
  };

  render() {
    const { error, itemsIds, totalCount, isLoading } = this.props;

    return (
      <SettingsPage>
        <SettingsPageHeader borderBottom gutterBottom={false}>
          <SettingsPageTitle>Локации</SettingsPageTitle>
        </SettingsPageHeader>
        <SettingsPageContent>
          <Table
            error={error}
            items={itemsIds}
            isLoading={isLoading}
            totalCount={totalCount}
          />
        </SettingsPageContent>
      </SettingsPage>
    );
  }
}

export default Locations;
